<div class="border-custom banner_e_boutique" style="padding-top: 40px;padding-bottom: 40px;background-position-x: 65%;background-image: url(../../../assets/images/bg_banner_v2_4.png); background-size: cover;">
  <div class="row w-100">
    <div class="col-1"></div>
    <div class="col-md-6 ps-5">
      <h2 class="m-0 PoppinsBold e-bootik">CRÉEZ VOTRE E-BOUTIQUE</h2>
      <p class="m-0 text-left PoppinsMedium" style="color: #000000;font-size: 13px;">Vendez tous vos articles et créations en ligne !</p>
      <button class="mt-3 btn-secondary PoppinsMedium" style="font-size: 12px;" (click)="goTo()">JE CRÉE MA E-BOUTIQUE GRATUITMENT</button>
    </div>
    <div class="col-md-4 offset-md-1 small-bootik">
      <div class="text-left mt-2">
        <div class="check-mark" style="font-size: 18px;">
          <mat-icon class="check-mark-icon" svgIcon="check-mark" style="width: 27px; height: 27px;"></mat-icon>
          <span class="PoppinsMedium" style="margin-left: 12px;">GRATUIT</span>
          <div class="check-mark-bg"></div>
        </div>
      </div>
      <div class="text-left mt-2">
        <div class="check-mark" style="font-size: 18px;">
          <mat-icon class="check-mark-icon" svgIcon="check-mark" style="width: 27px; height: 27px;"></mat-icon>
          <span class="PoppinsMedium" style="margin-left: 12px;">SANS ABONNEMENT</span>
          <div class="check-mark-bg"></div>
        </div>
      </div>
      <div class="text-left mt-2">
        <div class="check-mark" style="font-size: 18px;">
          <mat-icon class="check-mark-icon" svgIcon="check-mark" style="width: 27px; height: 27px;"></mat-icon>
          <span class="PoppinsMedium" style="margin-left: 12px;">SANS ENGAGEMENT</span>
          <div class="check-mark-bg"></div>
        </div>
      </div>
    </div>
  </div>
</div>